export default "{\n    \"yes\": \"Yes\",\n    \"no\": \"No\"\n}\n"